import { Liquid } from "liquidjs";

let liquid = null;

export function getLiquid(){
 if (!liquid){
     liquid = new Liquid();

     liquid.registerFilter('currency', (value, lang, currency)=>{
        lang = lang || 'de-DE';
        currency = currency || 'EUR';
        let numberFormat = new Intl.NumberFormat(lang, {style: 'currency', currency: currency });
        return  numberFormat.format(Number(value));
     });
     liquid.registerFilter('abs', (value)=>{
        const n = Number(value);
        return Number.isFinite(n) ? Math.abs(n) : value;
     });
 }
 return liquid;
}


// WEBPACK FOOTER //
// app/utils/liquid.js